/**
 * v0.23.2 (B-V2, QV2) — khi nào làm mới dải cảnh báo ở đầu web quầy.
 *
 * Tablet quầy để mở cả ngày không bao giờ tải lại `/v1/auth/toi` (chỉ đọc lúc mở app), nên việc người trong tiệm làm sau đó
 * (thêm Quản lý / Lễ tân, đặt mã hộ…) sẽ không hiện. Làm mới LẶNG LẼ: khi quay lại app sau ≥ 5 phút, và mỗi 15 phút khi trang
 * đang hiện. Hàm thuần để test; `Date.now()` ở nơi gọi là hẹn giờ giao diện, không phải mốc nghiệp vụ.
 */
export const NGUONG_LAM_MOI_DAI_MS = 5 * 60_000
export const CHU_KY_LAM_MOI_DAI_MS = 15 * 60_000

export function nenLamMoiDai(x: {
  lanCuoiMs: number
  bayGioMs: number
  dangHien: boolean
}): boolean {
  return x.dangHien && x.bayGioMs - x.lanCuoiMs >= NGUONG_LAM_MOI_DAI_MS
}
